module.exports = "pegasus/assets/tech/webinar/101.png";